import Route from '@ember/routing/route';
import { hash } from 'rsvp';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class AdminBlasterRoute extends Route {
  get queryParams() {
    return {
      section: {
        replace: true,
      },
    }
  }

  /**
   * Register services
   */
  @service('states/routes/admin/blaster') state;
  @service('state-managers/routes/admin/blaster') stateManager;
  @service router;

  /**
   * @inheritDoc
   */
  afterModel() {
    this.stateManager.registerOnNewPostingSelectedTransition((assignmentId) => {
      this.router.transitionTo(EMBER_ROUTE_NAMES.ADMIN__BLASTER, assignmentId);
    });

    this.stateManager.updateBlastStateFromAssignment();
    this.stateManager.updateToggleIsLoadingInitialState(false);
  }

  /**
   * @inheritDoc
   */
  model({ postingId }) {
    this.stateManager.initStateManager();
    this.stateManager.loadActiveAssignments();

    return hash({
      assignment: this.stateManager.loadAssignment(postingId),
      countries: this.stateManager.loadCountries(),
      equipment: this.stateManager.loadEquipment(),
      languages: this.stateManager.loadLanguages(),
      regions: this.stateManager.loadRegions(),
      services: this.stateManager.loadServices(),
    });
  }

  /** @inheritDoc */
  setupController(controller, model) {
    super.setupController(...arguments);

    controller.loadBlastHistory.perform(model.assignment);
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadBlastHistory.cancelAll();

      controller.setProperties({
        section: null,
        historyFilterBlast: null,
        historyFilterStatus: null,
        blastHistory: [],
      });
    }
  }
}

export default AdminBlasterRoute;
